var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"small":_vm.small},on:{"click":_vm.click}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-plus")]),_vm._v(" "+_vm._s(_vm.$t("createNewContact"))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }